import { useEffect, useState } from 'react'
import rpc from '@/src/rpc'
import LoadingSpinner from '@/components/LoadingSpinner'
import useDeviceInfo from '@/src/useDeviceInfo'
import ImageEditorPhone from './ImageEditorUI/ImageEditorPhone'
import ImageEditorDesktop from '@/components/ImageEditorUI/ImageEditorDesktop'


export default function ImageEditor({image, onCancel, onSave, mode, org}) {

  const [layers, setLayers] = useState(null)
  const [brandColors, setBrandColors] = useState([])

  const {portrait, mobile} = useDeviceInfo()
  const usePhoneLayout = mobile && portrait


  useEffect(() => {
    loadBrandColors()

    async function loadBrandColors () {
      try {
        const colors = await rpc('brandColors.all')
        setBrandColors(colors.map(c => c.hexValue))
      } catch (e) {
        console.error('Failed to load brand colors', e)
      }
    }
  }, [])


  useEffect(() => {
    loadLayers()

    async function loadLayers () {
      try {
        setLayers(
          await rpc('images.getLayers', {imageId: image && image.id}, {throwErrors: true})
        )
      } catch (e) {
        sendMessage('error', 'Image not available to edit')
        onCancel()
      }
    }
  }, [image, setLayers])

  const [fonts, setFonts] = useState()

  useEffect(() => {
    loadFonts()

    async function loadFonts () {
      setFonts( await rpc('fonts.backstage') )
    }
  }, [setFonts])


  if (!fonts) return <LoadingSpinner padded/>
  if (!layers) return <LoadingSpinner padded/>

  return <>
    {/* Preload the fonts to prevent delayed rendering */}
    <div className='invisible absolute pointer-events-none top left'>
      { fonts.map(font => (
        <div key={font.uid} style={{fontFamily: font.uid, fontSize: 1}}>
          preload
        </div>
      ))}
    </div>

    { usePhoneLayout ?
      <ImageEditorPhone
        image={image}
        layers={layers}
        brandColors={brandColors}
        fonts={fonts}
        onSave={onSave}
        onCancel={onCancel}
        mode={mode}
        org={org}
      />
    :
      <ImageEditorDesktop
        image={image}
        layers={layers}
        brandColors={brandColors}
        fonts={fonts}
        onSave={onSave}
        onCancel={onCancel}
        mode={mode}
        org={org}
      />
    }
  </>
}
